// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 600,
          textTransform: 'none',
          transition: 'box-shadow 0.2s ease',
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.shadows[2],
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: theme.shadows[4],
          },
        },
        containedSecondary: {
          boxShadow: theme.shadows[2],
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            boxShadow: theme.shadows[4],
          },
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        outlinedPrimary: {
          border: `1px solid ${theme.palette.primary.main}80`,
          '&:hover': {
            backgroundColor: `${theme.palette.primary.main}0A`,
            border: `1px solid ${theme.palette.primary.main}`,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textPrimary: {
          '&:hover': {
            backgroundColor: `${theme.palette.primary.main}0F`,
          },
        },
      },
    },
  };
}
